import { UsuarioList } from "../../../../../types/usuario/UsuarioList";

export interface Ouvidoria {
  id?: string;
  documento?: string;
  nome: string;
  email: string;
  sexo: string;
  telefone: string;
  categoria: string;
  formatoContato: string;
  observacao: string;
  dataHoraCriacao?: Date | string;
  anonimo?: boolean;
}
export const ISouvidoria: Ouvidoria = {
  id: '',
  categoria: '',
  documento: '',
  nome: '',
  email: '',
  sexo: '',
  telefone: '',
  formatoContato: '',
  observacao: '',
  dataHoraCriacao: '',
  anonimo: false
};
export interface OuvidoriaList {
  id: string;
  categoria: string;
  documento?: string;
  nome: string;
  email: string;
  sexo: string;
  telefone: string;
  anonimo?: boolean;
  formatoContato: string;
  observacao: string;
  dataHoraCriacao?: Date | string;
  arquivado?: boolean;
  resposta?: string;
  usuarioResposta?: UsuarioList | null;
  dataHoraResposta?: Date | string;
  historico?: OuvidoriaHistoricoList[];
}
export const ISouvidoriaList: OuvidoriaList = {
  id: '',
  categoria: '',
  documento: '',
  nome: '',
  email: '',
  sexo: '',
  telefone: '',
  formatoContato: '',
  observacao: '',
  anonimo: false,
  dataHoraCriacao: '',
  arquivado: false,
  resposta: '',
  usuarioResposta: null,
  dataHoraResposta: '',
  historico: []
};

export interface OuvidoriaDTO {
  id: string;
  idCategoria: string;
  documento?: string;
  nome: string;
  email: string;
  sexo: string;
  telefone: string;
  anonimo?: boolean;

  formatoContato: string;
  observacao: string;
}
export const ISouvidoriaDTO: OuvidoriaDTO = {
  id: '',
  idCategoria: '',
  documento: '',
  nome: '',
  email: '',
  sexo: '',
  telefone: '',
  formatoContato: '',
  observacao: '',
  anonimo: false
};

export interface OuvidoriaRespostaDTO {
  id: string;
  resposta: string;
}
export const ISouvidoriaRespostaDTO: OuvidoriaRespostaDTO = {
  id: '',
  resposta: ''
};

export interface OuvidoriaLoginResponse {
  id: string;
  login: string;
  senha: string;
}
export const ISouvidoriaLoginResponse: OuvidoriaLoginResponse = {
  id: '',
  login: '',
  senha: ''
};

export interface OuvidoriaLogin {
  login: string;
  senha: string;
}
export const ISouvidoriaLogin: OuvidoriaLogin = {
  login: '',
  senha: ''
};

export interface OuvidoriaListPublicResponse {
  results: OuvidoriaList[];
  count: number;
  next: string | null;
  previous: string | null;
}

export interface OuvidoriaHistoricoAddDTO {
  id: string;
  resposta: string;
}
export const ISouvidoriaHistoricoAddDTO: OuvidoriaHistoricoAddDTO = {
  id: '',
  resposta: ''
};

export interface OuvidoriaHistoricoList {
  id: string;
  idOuvidoria: string; 
  observacao: string;
  dataHora?: Date | string;  
  usuario?: UsuarioList | null;

}
export const ISouvidoriaHistoricoList: OuvidoriaHistoricoList = {
  id: '',
  idOuvidoria: '',
  observacao: '',
  dataHora: '',
  usuario: null,
  
}